import { Box, styled } from "@mui/material";
import { IconButton } from "@pmag/ui-components";
import { type HTMLAttributes } from "react";

export interface ExplosionGraphicHotspotProps extends HTMLAttributes<HTMLDivElement> {
    height: string;
    highlight: boolean;
    left: string;
    top: string;
    width: string;
}

export const ExplosionGraphicStickyBox = styled(Box)(({ theme }) => ({
    position: "sticky",
    top: theme.spacing(8),
}));

export const ExplosionGraphicBox = styled(Box)(({ theme }) => ({
    background: theme.palette.core.white,
    maxWidth: "100%",
    padding: theme.spacing(4),
    textAlign: "center",
}));

export const ExplosionGraphicImageContainer = styled("div")(() => ({
    position: "relative",
}));

export const ExplosionGraphicImage = styled("img")(() => ({
    display: "block",
    width: "100%",
    height: "auto",
}));

export const ExplosionGraphicHotspots = styled("div")(() => ({
    position: "absolute",
    inset: 0,
}));

export const ExplosionGraphicHotspot = styled("div")<ExplosionGraphicHotspotProps>(({ theme, left, top, width, height, highlight }) => ({
    position: "absolute",
    cursor: "pointer",
    borderRadius: "100%",
    transform: "translate(8%, -6%)",
    left,
    top,
    width,
    height,
    ...(highlight && {
        boxShadow: `0 0 0 2px ${theme.palette.blue._50}, inset 0 0 0 1px ${theme.palette.blue._50}`,
    }),
    "&:hover": {
        boxShadow: `0 0 0 2px ${theme.palette.blue._50}, inset 0 0 0 1px ${theme.palette.blue._50}`,
    },
}));

export const ExplosionExpandButton = styled(IconButton)(({ theme }) => ({
    position: "absolute",
    right: theme.spacing(4),
    top: theme.spacing(4),
    zIndex: 1,
}));
